module.exports = __webpack_public_path__ + "assets/img/25_342_big.17e4e1e0.jpg";